import { Link, NavLink } from "react-router-dom";
import React from "react";
import { useState, useEffect, useRef } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import Notification from "./Notification";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import NotificationsPreview from "../MyNotifications/NotificationsPreview";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { formateDate } from "../Shared/Utility";
export default function Header() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [dataArray, setDataArray] = useState([]);
  const [ShowFinance, SetShowFinance] = useState(false);
  const ShowHideFinance = () => {
    SetShowFinance(!ShowFinance);
  };
  const [showMaterials, SetShowMaterials] = useState(false);
  const showHideMaterials = () => {
    SetShowMaterials(!showMaterials);
  };

  const [showStorage, SetShowStorage] = useState(false);
  const showHideStorage = () => {
    SetShowStorage(!showStorage);
  };

  const [showOnlineStore, SetShowOnlineStore] = useState(false);
  const showHideOnlineStore = () => {
    SetShowOnlineStore(!showOnlineStore);
  };

  const [ShowEmployee, SetShowEmployee] = useState(false);
  const ShowHideEmployee = () => {
    SetShowEmployee(!ShowEmployee);
  };

  const [ShowGeneral, SetShowGeneral] = useState(false);
  const ShowHideGeneral = () => {
    SetShowGeneral(!ShowGeneral);
  };
  const [ShowWebsite, SetShowWebsite] = useState(false);
  const ShowHideWebsite = () => {
    SetShowWebsite(!ShowWebsite);
  };
  const [ShowConfiguration, SetShowConfiguration] = useState(false);
  const ShowHideConfiguration = () => {
    SetShowConfiguration(!ShowConfiguration);
  };

  const [ShowLeftMenu, SetShowLeftMenu] = useState(false);
  const ShowHideLeftMenu = () => {
    SetShowLeftMenu(!ShowLeftMenu);
  };
  const [ShowSubmenu, SetShowSubmenu] = useState(false);
  const ShowHideSubMenu = () => {
    SetShowSubmenu(!ShowSubmenu);
  };

  const [showTimeEntryIsPendingModal, setShowTimeEntryIsPendingModal] =
    useState(false);

  useEffect(() => {
    if (
      globalState.ShowTimeEntryIsPendingModalData &&
      globalState.ShowTimeEntryIsPendingModalData.length > 0
    ) {
      setShowTimeEntryIsPendingModal(true);
    } else {
      setShowTimeEntryIsPendingModal(false);
    }
  }, [globalState.ShowTimeEntryIsPendingModalData]);

  function getUserLoggedOut() {
    let object = {} as any;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/GetUserLoggedOut", object)
      .then((response) => {
        if (response.data.Status === 1) {
          window.location.href = "/login";
          setIsAnimation(true);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(true);
      });
  }

  const LogOutUser = () => {
    AppContext.SetCookie("Token", "", 0);
    AppContext.SetCookie("RefreshToken", "", 0);
    globalState.setLogInUserName("");
    globalState.setLogInUserImage("");
    globalState.setLogInUserRole("");
    AppContext.LogInUserName = "";
    window.location.href = "/login";
  };

  function NotificationCallBack() {
    globalState.setNotificationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
    });
  }

  return (
    <>
      <Notification
        NotificationObject={globalState.NotificationObject}
        NotificationCallBack={NotificationCallBack}
      />
      {isAnimation && <LoadingAnimation />}

      {globalState.LogInUserName !== "" && (
        <header className="flex-daj header">
          <div className="flex-da justify-btw reuse-width header-content">
            <div className="flex-d">
              <a className="flex-d show-980" onClick={ShowHideLeftMenu}>
                <img
                  className={`drop-icon ${ShowEmployee ? "rotate-open" : ""}`}
                  src="images/menu-bars.svg"
                  width={18}
                  height={16}
                />
              </a>
            </div>
            <nav className="nav-menu flex-da flex-gap15">
              {/* <a className="flex-daj" href="/mynotifications">
                <img src="/images/bell.svg" width="25" height="20" alt="Bell" />
              </a> */}
              <NotificationsPreview
                ObjectIds={""}
                ObjectType={1}
              ></NotificationsPreview>
              {/* {globalState.LogInUserName === "" && ( */}
              <div className="nav-item p-relative">
                <div className="sep-click">
                  <span
                    className="flex-da click-link open-drop pointer"
                    onClick={ShowHideSubMenu}
                  >
                    {globalState.LogInUserName}
                    <img
                      src="/images/arrow-down.svg"
                      width="9"
                      height="17"
                      alt="arrow down"
                      // className="hide-980"
                    />
                  </span>
                  {/* <a className="flex-da click-open">
                    <img
                      src="/images/arrow-down.svg"
                      width="9"
                      height="17"
                      alt="arrow down"
                      className="show-980"
                    />
                  </a> */}
                </div>
                {ShowSubmenu && (
                  <div className="sub-menu">
                    <Link to={""}>
                      <p>
                        {" "}
                        <a onClick={() => getUserLoggedOut()}>LogOut</a>
                      </p>
                    </Link>
                  </div>
                )}
              </div>
            </nav>
          </div>
        </header>
      )}

      {globalState.LogInUserName !== "" && (
        <div
          className={`left-menu custom-scroll ${
            ShowLeftMenu ? "Show-left-menu" : ""
          }`}
        >
          {showTimeEntryIsPendingModal == true && (
            <div className="left-menu-container">
              {AppContext.MNVMoverID > 0 && (
                <>
                  <div className="left-menu-items">
                    {AppContext.IsContractor == false && (
                      <>
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? "flex-da click-link active"
                              : "flex-da click-link"
                          }
                          to={"/employeetimelog"}
                        >
                          Employee Time Logs
                        </NavLink>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {showTimeEntryIsPendingModal == false && (
            <div className="left-menu-container">
              {AppContext.MNVMoverID == 0 &&
                AppContext.IsBlogAdmin == false &&
                (AppContext.IsAdmin || AppContext.IsSemiAdmin) && (
                  <>
                    <div className="left-menu-items">
                      {/* <a
                    className="flex-da click-link flex-jsb"
                    href="https://app.finestvan.co.uk/dashboard"
                  >
                    <span>Dashboard</span>
                  </a> */}

                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? "flex-da click-link active"
                            : "flex-da click-link"
                        }
                        to={"/allquotes"}
                      >
                        Quotes
                      </NavLink>

                      {/* <a
                    className="flex-da click-link flex-jsb"
                    href="https://app.finestvan.co.uk/allquotes"
                  >
                    <span>Quotes</span>
                  </a> */}

                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? "flex-da click-link active"
                            : "flex-da click-link"
                        }
                        to={"/calendar"}
                      >
                        Scheduling
                      </NavLink>
                      {/* <a
                    className="flex-da click-link flex-jsb"
                    href="https://app.finestvan.co.uk/calendar"
                  >
                    <span>Scheduling</span>
                  </a> */}
                    </div>
                    <div className="left-menu-items">
                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? "flex-da click-link active"
                            : "flex-da click-link"
                        }
                        to={"/courtesylivescreen"}
                      >
                        Courtesy Live Screen
                      </NavLink>
                    </div>

                    {AppContext.IsAdmin && (
                      <div className="left-menu-items">
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? "flex-da click-link active"
                              : "flex-da click-link"
                          }
                          to={"/statisticmenu"}
                        >
                          Statistic Menu
                        </NavLink>
                      </div>
                    )}

                    <div className="left-menu-items">
                      <a
                        className="flex-da click-link flex-jsb"
                        onClick={ShowHideFinance}
                      >
                        <span>Finance</span>
                        <img
                          className={`drop-icon ${
                            ShowFinance ? "rotate-open" : ""
                          }`}
                          src="images/chev-down.svg"
                          width={10}
                          height={10}
                        />
                      </a>
                      {ShowFinance && AppContext.MNVMoverID == 0 && (
                        <div className="left-sub-items">
                          {AppContext.IsSemiAdmin == false && (
                            <>
                              {/* <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/contractorview"}
                            >
                              Month Overview
                            </NavLink>{" "} */}
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/contractorview"}
                              >
                                Earnings
                              </NavLink>{" "}
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/tippingdashboard"}
                              >
                                Tipping
                              </NavLink>
                            </>
                          )}
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/invoicedata"}
                          >
                            Invoices
                          </NavLink>{" "}
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/receiptsdata"}
                          >
                            Receipts
                          </NavLink>
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/financecategories"}
                          >
                            Categories
                          </NavLink>
                        </div>
                      )}
                    </div>

                    <div className="left-menu-items">
                      <a
                        className="flex-da click-link flex-jsb"
                        onClick={ShowHideEmployee}
                      >
                        <span>Employee</span>
                        <img
                          className={`drop-icon ${
                            ShowEmployee ? "rotate-open" : ""
                          }`}
                          src="images/chev-down.svg"
                          width={10}
                          height={10}
                        />
                      </a>
                      {ShowEmployee &&
                        (!AppContext.IsContractor ||
                          AppContext.MNVMoverID == 0) && (
                          <div className="left-sub-items">
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/employeetimelog"}
                            >
                              Time Entry
                            </NavLink>

                            {AppContext.MNVMoverID == 0 && (
                              <>
                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/employeebonusanddeductions"}
                                >
                                  Bonus & Deductions
                                </NavLink>
                              </>
                            )}

                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/employeeview"}
                            >
                              Month Overview
                            </NavLink>

                            {AppContext.MNVMoverID == 0 && (
                              <>
                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/employeesummary"}
                                >
                                  Year Overview
                                </NavLink>
                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/employeerates"}
                                >
                                  Rates Payable
                                </NavLink>
                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/jobreview"}
                                >
                                  Online Reviews
                                </NavLink>
                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/jobreviewmonthlystats"}
                                >
                                  Online Reviews History
                                </NavLink>

                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/damageclaims"}
                                >
                                  Damage Claims / Complaints
                                </NavLink>

                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/warningsandperformanceissue"}
                                >
                                  Warnings / Performance Issue
                                </NavLink>

                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "flex-da click-link active"
                                      : "flex-da click-link"
                                  }
                                  to={"/marketingscore"}
                                >
                                  Marketing Score
                                </NavLink>

                                {/* <a
                              className="flex-da click-link flex-jsb"
                              href="https://app.finestvan.co.uk/marketingscore"
                            >
                              <span>Marketing Score</span>
                            </a> */}
                              </>
                            )}
                          </div>
                        )}
                    </div>

                    {AppContext.MNVMoverID == 0 && (
                      <div className="left-menu-items">
                        <a
                          className="flex-da click-link flex-jsb"
                          onClick={showHideMaterials}
                        >
                          <span>Materials</span>
                          <img
                            className={`drop-icon ${
                              showMaterials ? "rotate-open" : ""
                            }`}
                            src="images/chev-down.svg"
                            width={10}
                            height={10}
                          />
                        </a>
                        {showMaterials && (
                          <>
                            <div className="left-sub-items">
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/materialstemplatetype"}
                              >
                                Price Tables
                              </NavLink>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/materialslistprice"}
                              >
                                List Price
                              </NavLink>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/materialsjobs"}
                              >
                                Materials Jobs
                              </NavLink>
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {AppContext.MNVMoverID == 0 && (
                      <div className="left-menu-items">
                        <a
                          className="flex-da click-link flex-jsb"
                          onClick={showHideStorage}
                        >
                          <span>Storage</span>
                          <img
                            className={`drop-icon ${
                              showStorage ? "rotate-open" : ""
                            }`}
                            src="images/chev-down.svg"
                            width={10}
                            height={10}
                          />
                        </a>
                        {showStorage && (
                          <>
                            <div className="left-sub-items">
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/addressunit"}
                              >
                                Address Unit
                              </NavLink>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/storageprice"}
                              >
                                Storage Price
                              </NavLink>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/storagerecord"}
                              >
                                Storage Record
                              </NavLink>
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    <div className="left-menu-items">
                      <a
                        className="flex-da click-link flex-jsb"
                        onClick={showHideOnlineStore}
                      >
                        <span>Online Box Shop</span>
                        <img
                          className={`drop-icon ${
                            showOnlineStore ? "rotate-open" : ""
                          }`}
                          src="images/chev-down.svg"
                          width={10}
                          height={10}
                        />
                      </a>
                      {showOnlineStore && (
                        <>
                          <div className="left-sub-items">
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/productcategory"}
                            >
                              Product Category
                            </NavLink>

                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/products"}
                            >
                              Products
                            </NavLink>
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/productreview"}
                            >
                              Product Review
                            </NavLink>
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/orders"}
                            >
                              Orders
                            </NavLink>
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/orderinvoice"}
                            >
                              Order Invoice
                            </NavLink>
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "flex-da click-link active"
                                  : "flex-da click-link"
                              }
                              to={"/customers"}
                            >
                              Customers
                            </NavLink>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="left-menu-items">
                      <a
                        className="flex-da click-link flex-jsb"
                        onClick={ShowHideGeneral}
                      >
                        <span>General</span>
                        <img
                          className={`drop-icon ${
                            ShowGeneral ? "rotate-open" : ""
                          }`}
                          src="images/chev-down.svg"
                          width={10}
                          height={10}
                        />
                      </a>
                      {ShowGeneral && AppContext.MNVMoverID == 0 && (
                        <div className="left-sub-items">
                          {/* <a
                        className="flex-da click-link flex-jsb"
                        href="/notificationtemplates"
                      >
                        <span>Notification Templates</span>
                      </a> */}

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/clients"}
                          >
                            Clients
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/support"}
                          >
                            Support
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/myconversations"}
                          >
                            Messages
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/waconversations"}
                          >
                            WhatsApp Messages
                          </NavLink>
                        </div>
                      )}
                    </div>

                    <div className="left-menu-items">
                      <a
                        className="flex-da click-link flex-jsb"
                        onClick={ShowHideWebsite}
                      >
                        <span>Website</span>
                        <img
                          className={`drop-icon ${
                            ShowWebsite ? "rotate-open" : ""
                          }`}
                          src="images/chev-down.svg"
                          width={10}
                          height={10}
                        />
                      </a>
                      {ShowWebsite && AppContext.MNVMoverID == 0 && (
                        <div className="left-sub-items">
                          {/* <a
                        className="flex-da click-link flex-jsb"
                        href="https://app.finestvan.co.uk/blogarticle"
                      >
                        <span>Blog Article</span>
                      </a> */}
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/blogarticle"}
                          >
                            Blog Article
                          </NavLink>
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/blogauthor"}
                          >
                            Blog Author
                          </NavLink>
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/contentlibrary"}
                          >
                            Content Library
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/location"}
                          >
                            Locations
                          </NavLink>
                          {/* <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? "flex-da click-link active"
                            : "flex-da click-link"
                        }
                        to={"/pages"}
                      >
                        Pages
                      </NavLink> */}
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/userReview"}
                          >
                            User Review
                          </NavLink>
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/xml"}
                          >
                            XML
                          </NavLink>
                        </div>
                      )}
                    </div>

                    <div className="left-menu-items">
                      <a
                        className="flex-da click-link flex-jsb"
                        onClick={ShowHideConfiguration}
                      >
                        <span>Configuration</span>
                        <img
                          className={`drop-icon ${
                            ShowConfiguration ? "rotate-open" : ""
                          }`}
                          src="images/chev-down.svg"
                          width={10}
                          height={10}
                        />
                      </a>
                      {ShowConfiguration && AppContext.MNVMoverID == 0 && (
                        <div className="left-sub-items">
                          {AppContext.IsSemiAdmin == false && (
                            <>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/user"}
                              >
                                User
                              </NavLink>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/rates"}
                              >
                                Rates
                              </NavLink>
                            </>
                          )}

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/mover"}
                          >
                            Mover
                          </NavLink>
                          {AppContext.IsAdmin == true && (
                            <>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/moverrates"}
                              >
                                Mover Rates
                              </NavLink>
                            </>
                          )}
                          {/* <a
                        className="flex-da click-link flex-jsb"
                        href="https://app.finestvan.co.uk/moverunavailability"
                      >
                        <span>Mover Unavailability</span>
                      </a> */}

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/moverunavailability"}
                          >
                            Mover Unavailability
                          </NavLink>

                          {AppContext.IsAdmin == true && (
                            <>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/movertypes"}
                              >
                                Mover Types
                              </NavLink>

                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/vantypes"}
                              >
                                Van Types
                              </NavLink>

                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/van"}
                              >
                                Vans
                              </NavLink>
                            </>
                          )}

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/discount"}
                          >
                            Discount
                          </NavLink>
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/campaign"}
                          >
                            Campaign
                          </NavLink>
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/campaigndata"}
                          >
                            Campaign Data
                          </NavLink>
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/holiday"}
                          >
                            Holiday
                          </NavLink>

                          {AppContext.IsAdmin == true && (
                            <>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/timeslot"}
                              >
                                Time Slot
                              </NavLink>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/slots"}
                              >
                                Slots Management
                              </NavLink>
                            </>
                          )}

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/van_availability"}
                          >
                            Van Availability
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/largevans"}
                          >
                            Use Luton as Transit
                          </NavLink>

                          {AppContext.IsAdmin == true && (
                            <>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/systemconfiguration"}
                              >
                                System Configuration
                              </NavLink>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/emailtemplate"}
                              >
                                Email Template
                              </NavLink>
                              {/* <a
                            className="flex-da click-link flex-jsb"
                            href="https://app.finestvan.co.uk/generaldata"
                          >
                            <span>General Data</span>
                          </a> */}
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "flex-da click-link active"
                                    : "flex-da click-link"
                                }
                                to={"/generaldata"}
                              >
                                General Data
                              </NavLink>
                            </>
                          )}

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/minimumcharge"}
                          >
                            Minimum Charges
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/bankholiday"}
                          >
                            Bank Holidays
                          </NavLink>

                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "flex-da click-link active"
                                : "flex-da click-link"
                            }
                            to={"/generalinfo"}
                          >
                            General Info
                          </NavLink>

                          {/* <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? "flex-da click-link active"
                            : "flex-da click-link"
                        }
                        to={"/recentjob"}
                      >
                        Recent Jobs
                      </NavLink>

                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? "flex-da click-link active"
                            : "flex-da click-link"
                        }
                        to={"/locationstats"}
                      >
                        Location Stats
                      </NavLink>
                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? "flex-da click-link active"
                            : "flex-da click-link"
                        }
                        to={"/locationmove"}
                      >
                        Location Move
                      </NavLink> */}
                        </div>
                      )}
                    </div>
                  </>
                )}

              {AppContext.MNVMoverID == 0 && AppContext.IsBlogAdmin == true && (
                <>
                  <div className="left-menu-items">
                    {/* <a
                    className="flex-da click-link flex-jsb"
                    href="https://app.finestvan.co.uk/blogarticle"
                  >
                    <span>Blog Article</span>
                  </a> */}

                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "flex-da click-link active"
                          : "flex-da click-link"
                      }
                      to={"/blogarticle"}
                    >
                      Blog Article
                    </NavLink>
                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "flex-da click-link active"
                          : "flex-da click-link"
                      }
                      to={"/contentlibrary"}
                    >
                      Content Library
                    </NavLink>
                  </div>
                </>
              )}

              {AppContext.MNVMoverID > 0 && (
                <>
                  <div className="left-menu-items">
                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "flex-da click-link active"
                          : "flex-da click-link"
                      }
                      to={"/driverdashboard"}
                    >
                      Dashboard
                    </NavLink>

                    {AppContext.IsContractor == true && (
                      <>
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? "flex-da click-link active"
                              : "flex-da click-link"
                          }
                          to={"/contractorview"}
                        >
                          Earnings
                        </NavLink>{" "}
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? "flex-da click-link active"
                              : "flex-da click-link"
                          }
                          to={"/tippingdashboard"}
                        >
                          Tipping
                        </NavLink>
                      </>
                    )}
                    {AppContext.IsContractor == false && (
                      <>
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? "flex-da click-link active"
                              : "flex-da click-link"
                          }
                          to={"/employeeview"}
                        >
                          Employee View
                        </NavLink>
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? "flex-da click-link active"
                              : "flex-da click-link"
                          }
                          to={"/employeetimelog"}
                        >
                          Employee Time Logs
                        </NavLink>
                      </>
                    )}

                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "flex-da click-link active"
                          : "flex-da click-link"
                      }
                      to={"/damageclaims"}
                    >
                      Damage Claims / Complaints
                    </NavLink>

                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "flex-da click-link active"
                          : "flex-da click-link"
                      }
                      to={"/warningsandperformanceissue"}
                    >
                      Warnings / Performance Issue
                    </NavLink>

                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "flex-da click-link active"
                          : "flex-da click-link"
                      }
                      to={"/myconversations"}
                    >
                      Messages
                    </NavLink>

                    <NavLink
                      className={({ isActive }) =>
                        isActive
                          ? "flex-da click-link active"
                          : "flex-da click-link"
                      }
                      to={"/moverunavailability"}
                    >
                      Mover Unavailability
                    </NavLink>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {globalState.ShowTimeEntryIsPendingModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">
                  Pending Time Entries
                </h3>
                <a
                  className="close-help"
                  onClick={() =>
                    globalState.setShowTimeEntryIsPendingModal(false)
                  }
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="flow-auto-lg mt-10">
                <table className="reuse-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {globalState.ShowTimeEntryIsPendingModalData.map(
                      (Row: any, Index: any) => (
                        <tr key={Index}>
                          <td>{formateDate(Row.StartDateTime)}</td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() =>
                      globalState.setShowTimeEntryIsPendingModal(false)
                    }
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
